// const apiURL = "https://api.rossit99.online";
const apiURL = "https://api.tws22.com";
// const apiURL = "https://proit99.online";
// const apiURL = "http://localhost:5000";
const API_BASE_URL = `${apiURL}/api/v1`;

export { apiURL, API_BASE_URL };
